import { createContext, useContext, useLayoutEffect, useState } from 'react';

const STORAGE_KEY = 'usdx-theme';

const ThemeContext = createContext({ theme: 'light', toggleTheme: () => {} });

function initialTheme() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  // No stored choice yet — follow the OS preference, defaulting to light.
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(initialTheme);

  useLayoutEffect(() => {
    const root = document.documentElement;
    // The token blocks key off [data-theme]; the classes stay for any
    // third-party stylesheet that expects Tailwind's dark-class convention.
    root?.setAttribute('data-theme', theme);
    root?.classList?.remove('light', 'dark');
    root?.classList?.add(theme);
    root.style.colorScheme = theme;
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggleTheme = () => setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
